import angular from 'angular';
import Logger from '../../../shared/logger';

export const MessageService = (Restangular) => {
    const addMessage = function (message) {
        return Restangular.all('message')
            .post(message)
            .catch(error => Logger.error(error));
    };

    const searchMessage = function (data) {
        return Restangular.all('message')
            .all('search')
            .post(data)
            .catch(error => Logger.error(error));
    };

    return {
        addMessage,
        searchMessage,
    };
};

angular
    .module('TALENYA-FE')
    .factory('MessageService', MessageService);

